export default {
	services: '/jsApi/services',
	addresses: '/jsApi/addresses',
	serviceTimes: '/jsApi/serviceTimes',
	registrationRequest: '/jsApi/addReservation',
	marksModels: '/jsApi/marksModels',
	modifications: '/jsApi/modifications',
	oilFilter: '/jsApi/oilFilter',
	recommendedOil: '/jsApi/recommendedOil',
	airFilter: '/jsApi/airFilter',
	salonFilter: '/jsApi/salonFilter',
	changeFilter: '/jsApi/changePrice',
	orders: '/orderHistory/orders',
	searchLines: '/jsApi/searchSuggestion'
};
